import React, { useEffect } from 'react'
import { Dimmer, Grid, Loader } from 'semantic-ui-react'
import { RouteTypes } from '~/routes/constants'
import DashboardChart from '../DashboardChart'
import { FixedPricePrefixType } from '~/api/services/dashboard'
import { useTranslation } from 'react-i18next'
import SlotCard from '../SlotCard'
import { DashboardQuery } from '~/QueryHooks/DashboardQuery'

const MilkFixedPriceDashboard:React.FC = () => {
  const { t } = useTranslation()

  const {
    data: chartData,
    isLoading: isLoadingChartData
  } = DashboardQuery.getDashboardChartData(FixedPricePrefixType.FixedPrice)

  const {
    data: nextTradingData,
    isLoading: isLoadingNextData
  } = DashboardQuery.getDashboardNextTrading(FixedPricePrefixType.FixedPrice)

  const {
    data: previousTradingData,
    isLoading: isLoadingPreviousData
  } = DashboardQuery.getDashboardPreviousTrading(FixedPricePrefixType.FixedPrice)

  const {
    data: settings,
    isLoading: isLoadingSettings,
    refetch: refetchSettings
  } = DashboardQuery.getDashboardSettings(FixedPricePrefixType.FixedPrice)

  const slots = [
    {
      ...nextTradingData,
      title: t('Live / Next trading slot')
    },
    {
      ...previousTradingData,
      title: t('Last trading slot')
    }]

  useEffect(() => {
    refetchSettings()
  }, [t])

  function renderSlotCards() {
    return slots.map((tradingSlot, index) => {
      return <Grid.Column key={index}>
        <SlotCard
          tradingSlotCard={tradingSlot}
          settingsData={settings}
          url={{
            show: RouteTypes.MILK_FIXED_PRICE_SHOW.replace(':id', tradingSlot?.id),
            results: RouteTypes.MILK_FIXED_PRICE_RESULTS.replace(':id', tradingSlot?.id),
            offer:  RouteTypes.MILK_FIXED_PRICE_OFFER_AMOUNT.replace(':id', tradingSlot?.id)
          }}
          prefix={FixedPricePrefixType.FixedPrice}
        />
      </Grid.Column>
    })
  }

  const isLoading = isLoadingChartData || isLoadingNextData || isLoadingPreviousData || isLoadingSettings

  return <Grid columns={2} style={{ marginTop: '1em' }}>
    <Dimmer inverted active={isLoading}>
      <Loader inverted active={isLoading}/>
    </Dimmer>
    {!isLoading && renderSlotCards()}
    {!isLoading && chartData && <Grid.Row>
      <DashboardChart
        chartData={chartData}
        link={RouteTypes.REPORTING_TRADING_ACTIVITIES.replace(':prefix', FixedPricePrefixType.FixedPrice)}
        prefix={FixedPricePrefixType.FixedPrice}
      />
    </Grid.Row>}
  </Grid>
}
export default MilkFixedPriceDashboard